module.exports = __webpack_public_path__ + "img/1L2.98f0711e.png";